const VisionMission = () => {
  const items = [
    {
      icon: 'ri-eye-line',
      title: 'رؤيتنا',
      description: 'أن نكون الشركة الرائدة في المملكة والمنطقة في توفير الحلول الأمنية المتكاملة، ونساهم في بناء مجتمع آمن من خلال تقديم أحدث التقنيات وأفضل الخدمات التي تحمي الأرواح والممتلكات.',
    },
    {
      icon: 'ri-compass-3-line',
      title: 'رسالتنا',
      description: 'نلتزم بتقديم حلول أمنية متطورة وموثوقة تلبي احتياجات عملائنا المتنوعة، من خلال فريق محترف ومعدات عالية الجودة، مع ضمان أعلى معايير الخدمة والدعم الفني المستمر.',
    },
    {
      icon: 'ri-flag-line',
      title: 'أهدافنا',
      description: 'تحقيق رضا العملاء الكامل من خلال تقديم خدمات متميزة، التوسع في تقديم حلول أمنية مبتكرة، بناء شراكات استراتيجية مع أفضل الشركات العالمية، والمساهمة في رفع مستوى الأمن في المملكة.',
    },
    {
      icon: 'ri-heart-line',
      title: 'قيمنا',
      description: 'الاحترافية في العمل، الالتزام بالجودة، الأمانة والشفافية مع العملاء، الابتكار المستمر، العمل بروح الفريق، والمسؤولية الاجتماعية تجاه المجتمع والبيئة.',
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-navy-light mb-6">
            رؤيتنا <span className="text-primary">ورسالتنا</span>
          </h2>
          <p className="text-lg text-gray-dark max-w-2xl mx-auto">
            نؤمن بأهمية الأمن والحماية ونسعى لتحقيق التميز في كل ما نقدمه
          </p>
        </div>

        {/* Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {items.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl p-12 shadow-lg hover:shadow-2xl transition-all-300 border border-gray-medium/10"
            >
              {/* Icon */}
              <div className="w-20 h-20 flex items-center justify-center rounded-2xl bg-gradient-to-br from-primary to-primary-dark mb-6">
                <i className={`${item.icon} text-4xl text-white`}></i>
              </div>

              {/* Title */}
              <h3 className="text-3xl font-bold text-navy-light mb-4">
                {item.title}
              </h3>

              {/* Description */}
              <p className="text-gray-dark text-base leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VisionMission;